import dayjs from 'dayjs';

export const DATE_VIEW_FORMAT = 'DD.MM.YYYY';
export const DATE_WITH_TIME_VIEW_FORMAT = 'DD.MM.YYYY HH:mm:ss';

function isValidDateValue(value: unknown, inputDateFormat?: string): value is string | number | Date {
  return typeof value === 'string'
    ? dayjs(value, inputDateFormat).isValid()
    : Boolean(value) && dayjs(value as dayjs.Dayjs, inputDateFormat).isValid();
}

export function dateToIsoString(date?: unknown): string | undefined {
  if (!isValidDateValue(date)) {
    return undefined;
  }
  return new Date(date).toISOString();
}

export function formatDate({
  date,
  outputFormat,
  inputFormat,
  needTime,
}: {
  date?: unknown;
  outputFormat?: string;
  inputFormat?: string;
  needTime?: boolean;
}): string | undefined {
  if (!date || !isValidDateValue(date, inputFormat)) {
    return;
  }
  const dateFormat = outputFormat || (needTime ? DATE_WITH_TIME_VIEW_FORMAT : DATE_VIEW_FORMAT);

  if (inputFormat) return dayjs(date, inputFormat).format(dateFormat);
  return dayjs(new Date(date)).format(dateFormat);
}

// добавляет нули перед днем и месяцом, если 1 число
export const addZeroToDate = (value?: number): string => {
  if (value) return ('0' + value).slice(-2);
  return '';
};
